<template>
  <div class="main-header" :class="{ 'main-header-browsing': browsing }" :style="'background-image: url(' + backgroundImage + ')'">
    <div class="main-header-overlay">
      <div class="container">
        <div class="container-element">
          <h1>Close more deals, faster with PFX</h1>
          <h2>PFX powers broker branded auctions that simplify the sales process for buyers, sellers and agents. </h2>
          <div class="buttons" v-if="!browsing">
            <button class="btn-rounded fat" @click="$store.commit('openGetStartedDialog')">Get Started</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FrontPagePfxBanner',
    props: {
      browsing: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        backgroundImage: require('../assets/landing-page-background.jpg')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';
  $main-header-min-height: 30rem;

  .main-header {
    background-size: cover;
    background-position: center;
    height: 100vh;
    min-height: $main-header-min-height;
    width: 100%;
    color: $color-white;

    .main-header-overlay {
      background-color: rgba(#002323, 0.5);
      background-image:
        radial-gradient(circle at 50% 50%, rgba(74, 74, 74, 0.25), rgba(74, 74, 74, 0)),
        radial-gradient(circle at 50% 11%, rgba(255, 255, 255, 0.25), rgba(0, 0, 0, 0.25));
    }

    .container {
      height: 100vh;
      min-height: $main-header-min-height;
      padding: 1rem;
      position: relative;

      .container-element {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 60vw;
        text-align: center;
        @include tablet-portrait-breakpoint {
          width: 700px;
        }
      }

      h1 {
        font-weight: 700;
        font-size: 24px;
        font-family: 'Encode Sans', sans-serif;
        line-height: 1.25em;
        letter-spacing: 0;
        margin: 0 auto;
        max-width: 800px;
        @include tablet-portrait-breakpoint {
          font-size: 32px;
        }
      }

      h2 {
        font-family: 'Encode Sans', sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 1.25em;
        margin: 2rem auto 0;
        max-width: 500px;
        @include tablet-portrait-breakpoint {
          font-size: 24px;
        }
      }

      .buttons {
        margin-top: 32px;
      }
    }

  }

  .main-header.main-header-browsing {
    height: 50vh;
    .container {
      height: 50vh;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/FrontPagePfxBanner.vue